<template>
    <v-container fluid grid-list-xl>
        <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" mt-5>
                <h1>{{this.$t('new_publication_section_title')}}</h1>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 mt-3>
                <form @submit.prevent="sendPublication">
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm12>
                            <api-result-viewer :data="api_response"></api-result-viewer>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                            <v-text-field v-model="title_publication" :label="this.$t('title_publication_input_label')" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                            <v-select
                                    :items="types"
                                    name="publication_type"
                                    :label="this.$t('publication_type_input_label')"
                                    v-model="type"
                                    item-text="name"
                                    required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-switch v-model="silent_publication" :label="this.$t('silent_publication_input_label')"></v-switch>
                        </v-flex>

                        <v-flex xs12 sm12 v-if="type === 'simple'">
                            <v-text-field v-model="text_publication" :label="this.$t('text_publication_input_label')" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 v-if="type === 'text'">
                            <v-textarea v-model="text_publication" :label="this.$t('text_publication_input_label')" required></v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 v-if="type === 'link'">
                            <v-text-field v-model="url_publication" :label="this.$t('url_publication_input_label')" type="url" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 v-if="type === 'markdown'">
                            <easymde v-model="body_publication"></easymde>
                        </v-flex>
                        <v-flex xs12 sm12 class="text-xs-center" mt-5>
                            <v-btn color="primary" type="submit" v-if="api_response !== 1">{{this.$t('send_publication_btn_message')}}</v-btn>
                        </v-flex>
                    </v-layout>
                </form>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import easymde from "../components/easymde";
    import ApiResultViewer from '../components/api/APIResultViewer'
    import PublicationService from "../apiServices/PublicationService";


    function getDefaultData() {
        return {
            types : ['simple', 'text', 'link', 'markdown'],
            type : null,
            title_publication : null,
            silent_publication: false,
            text_publication: null,
            url_publication:null,
            body_publication: null,
            api_response: 0
        }
    }

    export default {
        name: "NewPublication",
        data(){
            return getDefaultData()
        },
        methods:{
            sendPublication(){
                let dataToSend = {
                    type: this.type,
                    title: this.title_publication,
                    silent_publication: this.silent_publication
                }
                switch (this.type) {
                    case 'simple':
                        dataToSend.text = this.text_publication
                        break;
                    case 'text':
                        dataToSend.text = this.text_publication
                        break;
                    case 'link':
                        dataToSend.url = this.url_publication
                        break;
                    case 'markdown':
                        dataToSend.body = this.body_publication
                        break;
                }
                this.api_response = 1;
                PublicationService.publish(dataToSend)
                    .then(() => {
                        this.resetFields()
                        this.$swal(this.$t('publish_ok_message'), '', 'success')
                        this.api_response = 0
                    })
                    .catch(error => {
                        this.api_response = error
                    })
            },
            resetFields: function() {
                // Fetch the initialState object locally, so we do not have to call the function again
                let initialData = getDefaultData();
                // Iterate through the props
                for (let prop in initialData) {
                    // Reset the prop locally.
                    this[prop] = initialData[prop];
                }
            }
        },
        components: {
            easymde,
            ApiResultViewer
        }
    }
</script>

<style scoped>
</style>

<i18n>
    {
        "en": {
            "new_publication_section_title": "New Publication",
            "title_publication_input_label": "Title",
            "publication_type_input_label": "Select a type",
            "silent_publication_input_label": "Silent publication?",
            "text_publication_input_label": "Text",
            "url_publication_input_label": "Link",
            "send_publication_btn_message": "Send!",
            "publish_ok_message": "Published!!"
        },
        "es": {
            "new_publication_section_title": "Nueva publicación",
            "title_publication_input_label": "Título",
            "publication_type_input_label": "Seleccionar un tipo",
            "silent_publication_input_label": "Publicación silenciosa?",
            "text_publication_input_label": "Texto",
            "url_publication_input_label": "Enlace",
            "send_publication_btn_message": "Enviar!",
            "publish_ok_message": "Publicado!!"
        }
    }
</i18n>